import { ILocalizedError, IReservationGuarantee } from '@localina/core';
import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { LocalinaApiContext } from '../../../index';
import { TGuaranteeAction } from '../../interfaces';
import { useRestaurantId } from '../../utils/RestaurantUtils';
import { queryKeys } from './query-keys';

// No-Show Protection: actions on the guarantee of a reservation. "charge" and "refund" are only allowed for the
// host or Chef de Service (feature "noShowCharge"), plus support; the backend enforces it.

const useGuaranteeActionMutation = (
    action: TGuaranteeAction,
    options?: UseMutationOptions<
        IReservationGuarantee,
        ILocalizedError,
        { reservationId: string; channels?: string[] }
    >,
) => {
    const queryClient = useQueryClient();
    const restaurantId = useRestaurantId();
    return useMutation({
        mutationFn: ({ reservationId, channels }) =>
            LocalinaApiContext.serviceApi.guaranteeAction(restaurantId, reservationId, action, channels),
        // the guarantee and possibly the reservation status changed
        onSettled: () => queryClient.invalidateQueries(queryKeys.restaurants.single.reservations.all(restaurantId)),
        ...options,
    });
};

export { useGuaranteeActionMutation };
